<template>
  <card> </card>
</template>
<script>
export default {
  name: "disciplines",
  mounted() {
            localStorage.clear()
    this.$router.push("/");
    setTimeout(() => {
      this.$store.dispatch("setUser", null);
  
          this.$http.defaults.headers.common["Authorization"] = '' ;
    }, 10);
  },
};
</script>
<style>
</style>
